<h2>EDIZIONE 2011</h2>
<ul>
	<li>Le CryptoWars2011 sono un'iniziativa del Laboratorio di Matematica Industriale e Crittografia (Univ. di Trento)
		a scopo divulgativo.</li>
	<li>Singoli appassionati o team si scontrano nel periodo Ottobre 2011- Febbraio 2012 creando codici e rompendo i
		codici degli altri!
		Team di studenti universitari sono particolarmente benvenuti. </li>
	<li>Sono previste tre categorie, di difficoltà crescente. </li>
</ul>
<p>
	L'iniziativa viene presentata durante speciali riunioni, chiamate CryptoWarsCamp,
	molto importanti per organizzare i team.
</p>
<div id="descrizioGara">
	<h3>Descrizione della gara</h3>
	<p>Allo scopo di diffondere e suscitare l'interesse nella Crittografia, abbiamo
		organizzato le CryptoWars2011, ovvero una competizione di crittografia a livello
		nazionale. </p>
	<div id="tempistiche">
		<h6>La tempistica</h6>
		<ul>
			<li>
				12 Settembre 2011: inizio iscrizioni dei concorrenti,
				presentazione formale della gara durante il Workshop
				<a href="http://www.science.unitn.it/~sala/BunnyTN/index2011_sept.html">
					BunnyTN2011. </a>
			</li>
			<li>
				20 Ottobre 2011: termine iscrizioni.</li>
			<li>
				14 Novembre 2011: inizio gara.</li>
			<li>
				10 Marzo 2012: fine gara.</li>
			<li>
				12 Marzo 2012: premiazione dei vincitori durante il Workshop <a href="http:
					//www.science.unitn.it/~sala/BunnyTN/index2012_march.html"> BunnyTN2012. </a></li>
		</ul>
	</div>
	<div id="categorie">
		<h6>Categorie</h6>
		<p>La gara è divisa in tre categorie. I concorrenti, che possono essere team o singoli, possono partecipare a
			una o più delle tre categorie. </p>
		<ul>
			<li> Categoria classica. <br>
				Questa si basa su algoritmi classici (nel senso di pre-Shannon), ovvero polialfabetici, che in teoria si
				possono rompere anche con carta e matita e buona intuizione.
				Ogni concorrente deve scegliersi un sistema e cifrare un testo fornito da noi, dopodichè deve rompere le
				cifre degli altri!
				Questa categoria è aperta anche a studenti delle scuole superiori (<a
					href="../../../../../assets/attivita/cryptowars/2011/loc.pdf">locandina</a>).
			</li>
			<li> Categoria chiave pubblica. <br>
				Proponiamo una serie di chiavi pubbliche da rompere, di difficoltà
				crescente e quindi con punteggio diverso. In maggior parte RSA, ma anche
				qualche altri sistemi. Man mano che una chiave è rotta, i punti sono
				assegnati e la chiave viene ritirata.
			</li>
			<li> Categoria chiave simmetrica. <br>
				Proponiamo un sistema simmetrico da attaccare. Questa categoria è molto tecnica.
				Qui ci possono essere moltissimi scenari di attacco, quindi non diamo
				un obiettivo preciso, ma premiamo quello che ci sembrerà l'attacco
				più significativo. Siamo più che contenti di premiarne anche un paio!
			</li>
		</ul>
	</div>
	<div id="premiazione">
		<h6>Premiazione</h6>
		<ul>
			<li>I vincitori sono premiati durante il Workshop che abbiamo in programma a
				Marzo 2012. </li>
			<li>Ciascuna squadra vincitrice, una per categoria (a meno che non ci siano
				pareggi), riceve 5 copie con licenza del software dell'azienda PrivateWave
				per fare telefonate cifrate. </li>
			<li>Ciascuna squadra vincitrice riceve inoltre 3 chiavette iTwin per far
				comunicare due computer in maniera sicura.</li>
			<li>Il 12 Marzo 2012 al Workshop BunnyTN premiamo una persona in
				rappresentanza del team vincente (una per ogni categoria). Il premio
				consiste nell'alloggio e vitto durante il Workshop, più ovviamente
				la gloria immortale (il Workshop e la premiazione sono trasmessi in
				streaming).</li>
		</ul>
	</div>
</div>

<div id="teamGara">
	<h3>I team in gara</h3>
	<h6><i>Categoria classica:</i></h6>
	<ul>
		<li> Milano, <font color="blue">Crackers</font>, <font color="red"><i>Martino Borello</i></font>,
			martino.borello&#64;gmail.com </li>
		<li> Milano, <font color="blue">MAC-MilanoAttaccaChiunque</font>, <font color="red"><i>Chiara Schiavo</i></font>
			, chiara.schiavo&#64;unimi.it</li>
		<li> Milano, <font color="blue">MilanoForFun</font>, <font color="red"><i>Andrea Posadino</i></font>,
			andreaposadino&#64;gmail.com</li>
		<li> Milano, <font color="blue">The Wild Bunch</font>, <font color="red"><i>Gabriele Spini</i></font>,
			gabriele.spini&#64;gmail.com</li>
		<li> Napoli, <font color="blue">Code-breaker</font>, <font color="red"><i>Andrea Di Palma</i></font>,
			andream.dipalma&#64;libero.it</li>
		<li> Perugia, <font color="blue">Crypto-Grifo</font>, <font color="red"><i> Marco Baioletti</i> </font>,
			baioletti&#64;dipmat.unipg.it</li>
		<li> Pisa, <font color="blue">CryptoCocchi</font>, <font color="red"><i>Daniele</i></font>,
			tas&#64;paranoici.org </li>
		<li> Roma, <font color="blue">aRM3d</font>, <font color="red"><i> Bernardo Palazzi</i></font>,
			bernardo&#64;bernardo.it</li>
		<li> Roma, <font color="blue">Gesmer</font>, <font color="red"><i> Giulio Aliberti</i></font>,
			giulio.alib&#64;gmail.com</li>
		<li> Torino, <font color="blue">A. Mathison T.</font>, <font color="red"><i>Federico</i></font>,
			fedehousej&#64;hotmail.it</li>
		<li> Torino, <font color="blue">Shuana</font>, <font color="red"><i>Giulia</i></font>, giux.jei.giu&#64;live.it
		</li>
		<li> Torino, <font color="blue">Cryptonite</font>, <font color="red"><i>Stefania Vanzetti</i> </font>,
			stefaniavanzetti&#64;gmail.com </li>
		<li> Torino, <font color="blue">upsjop11</font>,<font color="red"> <i>Matteo Ghigo</i></font>,
			matteoghigo&#64;gmail.com </li>
		<li> Trento, <font color="blue">Crackers Salati (Informatica) </font>, <font color="red"><i>Federico Scrinzi</i>
			</font>, fox91 AT anche DOT no</li>
		<li> Udine, <font color="blue">Wir BITte?</font>, <font color="red"><i>Lorenzo Antoniazzi</i></font>,
			antoniazzi.lorenzo&#64;spes.uniud.it </li>
	</ul>

	<font color="green">Numero totale di iscritti al momento alla categoria classica: più di 150.</font>
	<br>
	<br>

	<h6><i>Categoria chiave pubblica:</i></h6>
	<ul>
		<li> Milano, <font color="blue">Crackers</font>, <font color="red"><i>Martino Borello</i></font>,
			martino.borello&#64;gmail.com </li>
		<li> Milano, <font color="blue">MAC-MilanoAttaccaChiunque</font>, <font color="red"><i>Chiara Schiavo</i></font>
			, chiara.schiavo&#64;unimi.it</li>
		<li> Milano, <font color="blue">The Wild Bunch</font>, <font color="red"><i>Gabriele Spini</i></font>,
			gabriele.spini&#64;gmail.com</li>
		<li> Perugia, <font color="blue">Crypto-Grifo</font>, <font color="red"><i> Marco Baioletti</i> </font>,
			baioletti&#64;dipmat.unipg.it</li>
		<li> Pisa, <font color="blue">CryptoCocchi</font>, <font color="red"><i>Daniele</i></font>,
			tas&#64;paranoici.org </li>
		<li> Roma, <font color="blue">aRM3d</font>, <font color="red"><i> Bernardo Palazzi</i></font>,
			bernardo&#64;bernardo.it</li>
		<li> Roma, <font color="blue">Enimmista</font>, <font color="red"><i>Marco Valenti</i></font>,
			valentimar&#64;gmail.com</li>
		<li> Roma, <font color="blue">Gab84RM</font>, <font color="red"><i>Gabriele Pulvano</i></font>,
			gabrieleplv&#64;libero.it</li>
		<li> Torino, <font color="blue">Cryptonite</font>, <font color="red"><i>Stefania Vanzetti</i> </font>,
			stefaniavanzetti&#64;gmail.com </li>
		<li> Udine, <font color="blue">Wir BITte?</font>, <font color="red"><i>Lorenzo Antoniazzi</i></font>,
			antoniazzi.lorenzo&#64;spes.uniud.it </li>
	</ul>

	<h6><i>Categoria chiave simmetrica:</i></h6>
	<ul>
		<li> Milano, <font color="blue">Crackers</font>, <font color="red"><i>Martino Borello</i></font>,
			martino.borello&#64;gmail.com </li>
		<li> Milano, <font color="blue">MAC-MilanoAttaccaChiunque</font>, <font color="red"><i>Chiara Schiavo</i></font>
			, chiara.schiavo&#64;unimi.it</li>
		<li> Milano, <font color="blue">The Wild Bunch</font>, <font color="red"><i>Gabriele Spini</i></font>,
			gabriele.spini&#64;gmail.com</li>
		<li> Perugia, <font color="blue">Crypto-Grifo</font>, <font color="red"><i> Marco Baioletti</i> </font>,
			baioletti&#64;dipmat.unipg.it</li>
		<li> Pisa, <font color="blue">CryptoCocchi</font>, <font color="red"><i>Daniele</i></font>,
			tas&#64;paranoici.org </li>
		<li> Pisa, <font color="blue">m19700530</font>, <font color="red"><i>Marco Pellegrini</i></font>,
			m19700530&#64;hotmail.com</li>
		<li> Roma, <font color="blue">aRM3d</font>, <font color="red"><i> Bernardo Palazzi</i></font>,
			bernardo&#64;bernardo.it</li>
		<li> Roma, <font color="blue">Enimmista</font>, <font color="red"><i>Marco Valenti</i></font>,
			valentimar&#64;gmail.com</li>
		<li> Roma, <font color="blue">Gesmer</font>, <font color="red"><i> Giulio Aliberti</i></font>,
			giulio.alib&#64;gmail.com</li>
		<li> Udine, <font color="blue">Wir BITte?</font>, <font color="red"><i>Lorenzo Antoniazzi</i></font>,
			antoniazzi.lorenzo&#64;spes.uniud.it </li>
	</ul>
	<br>
	<br>
</div>
<div id="classifica">
	<h3>Classifica</h3>
	<h6>
		<font color="blue">Categoria Classica</font>
	</h6>
	<table border="1" cellpadding="4" cellspacing="0" width="90%" align="center">
		<tbody>
			<tr>
				<td>TEAM</td>
				<td>GARA 1</td>
				<td>SFIDE</td>
				<td>TOTALE</td>
			</tr>
			<tr>
				<td>&nbsp;<font color="red"><b>aRM3d</b></font>&nbsp;</td>
				<td>30&nbsp;</td>
				<td>2+5+7+9+<font color="green">15</font>
				</td>
				<td>53+<font color="green">15</font>=<font color="red"><b>68</b></font>
				</td>
			</tr>
			<tr>
				<td>&nbsp;<font color="orange"><b>Cryptonite</b></font>
				</td>
				<td>50&nbsp;</td>
				<td>3+5</td>
				<td>58+<font color="blue">5</font>=<font color="orange"><b>63</b></font>
				</td>
			</tr>
			<tr>
				<td>&nbsp;<font color="purple"><b>Wir BITte?</b></font>
				</td>
				<td>50&nbsp;</td>
				<td>3+5</td>
				<td>
					<font color="purple"><b>58</b></font>
				</td>
			</tr>
			<tr>
				<td>&nbsp;CrackerSalati</td>
				<td>30&nbsp;</td>
				<td>3+5</td>
				<td>38</td>
			</tr>
			<tr>
				<td>&nbsp;The Wild Bunch</td>
				<td>30&nbsp;</td>
				<td>3+5</td>
				<td>38</td>
			</tr>
			<tr>
				<td>&nbsp;upsjop11</td>
				<td>30&nbsp;</td>
				<td>0</td>
				<td>30</td>
			</tr>
			<tr>
				<td>&nbsp;Milano For Fun</td>
				<td>10&nbsp;</td>
				<td>3+5+7</td>
				<td>25</td>
			</tr>
			<tr>
				<td>&nbsp;Gesmer</td>
				<td>20&nbsp;</td>
				<td>3</td>
				<td>23</td>
			</tr>
			<tr>
				<td>&nbsp;MAC</td>
				<td>10&nbsp;</td>
				<td>3+5</td>
				<td>18</td>
			</tr>
			<tr>
				<td>&nbsp;Crypto-Grifo</td>
				<td>10&nbsp;</td>
				<td>3</td>
				<td>13</td>
			</tr>
			<tr>
				<td>&nbsp;CryptoCocchi</td>
				<td>10&nbsp;</td>
				<td>0</td>
				<td>10</td>
			</tr>
			<tr>
				<td>&nbsp;Crackers</td>
				<td>0&nbsp;</td>
				<td>3</td>
				<td>3</td>
			</tr>
			<tr>
				<td>&nbsp;Shuana</td>
				<td>0&nbsp;</td>
				<td>0</td>
				<td>0</td>
			</tr>
			<tr>
				<td>&nbsp;A.Mathison T.</td>
				<td>0&nbsp;</td>
				<td>0</td>
				<td>0</td>
			</tr>
			<tr>
				<td>&nbsp;Code-Breakers</td>
				<td>0&nbsp;</td>
				<td>0</td>
				<td>0</td>
			</tr>
		</tbody>
	</table>
	<br>
	<h6>
		<font color="blue">Categoria Pubblica</font>
	</h6>
	<table border="1" cellpadding="4" cellspacing="0" width="90%" align="center">
		<tbody>
			<tr>
				<td><b>TEAM</b></td>
				<td>&nbsp;<b>RSA</b></td>
				<td>&nbsp;<b>ECC</b></td>
				<td><b>TOTALE</b></td>
			</tr>
			<tr>
				<td>
					<font color="red"><b>Cryptonite</b></font>
				</td>
				<td>&nbsp;10+8*20+4*50+50</td>
				<td>&nbsp;150+3*50</td>
				<td>&nbsp;<font color="red"><b>720</b></font>
				</td>
			</tr>
			<tr>
				<td>Wir BITte?</td>
				<td>&nbsp;50</td>
				<td>0</td>
				<td>50&nbsp;</td>
			</tr>
			<tr>
				<td>Crypto-Grifo</td>
				<td>&nbsp;10</td>
				<td>&nbsp;0</td>
				<td>&nbsp;10</td>
			</tr>
			<tr>
				<td>Crackers</td>
				<td>&nbsp;10</td>
				<td>&nbsp;0</td>
				<td>&nbsp;10</td>
			</tr>
			<tr>
				<td>MAC</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>&nbsp;TWB</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>CryptoCocchi</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>aRM3d</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>Enimmista</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>Gab84RM</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
				<td>&nbsp;0</td>
			</tr>
		</tbody>
	</table>
	<br>
	<h6>
		<font color="blue">Categoria Simmetrica</font>
	</h6>
	<table border="1" cellpadding="4" cellspacing="0" width="90%" align="center">
		<tbody>
			<tr>
				<td><b>TEAM</b></td>
				<td><b>TOTALE</b></td>
			</tr>
			<tr>
				<td>
					<font color="red"><b>Wir BITte?</b></font>
				</td>
				<td>
					<font color="red"><b>100</b></font>
				</td>
			</tr>
			<tr>
				<td>Gesmer</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>Crackers</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>MAC</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>TWB</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>Crypto-Grifo</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>CryptoCocchi</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>aRM3d</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>Enimmista</td>
				<td>&nbsp;0</td>
			</tr>
			<tr>
				<td>m19700530</td>
				<td>&nbsp;0</td>
			</tr>
		</tbody>
	</table>

	<br>
	<p>Per ulteriori informazioni e domande scrivere a mathnow.unitn&#64;gmail.com</p>

</div>
<div id="Sponsor">
	<h3>Sponsor</h3>
	<ul>
		<li>Le nostre Wars sono possibili solo grazie alla presenza di sponsors illuminati, che ringraziamo
			calorosamente.</li>
		<li>Abbiamo deciso un numero massimo di 6 sponsors, e per il momento abbiamo i seguenti:
			<ul>
				<li>
					<font color=blue> Alpha Orionis Srl, Milano</font>, azienda attiva nella sicurezza in ambito
					<i>Finance</i>,
				</li>
				<li><a href="http://confidace.it/">
						<font color=blue> Ceremit Srl, Thiene</font>
					</a>, azienda specializzata
					in <i>Consulting Engineering</i>,</li>
				<li><a href="http://www.seeweb.it/">
						<font color=blue> SeeWeb</font>
					</a>, il piu' grande <i>cloud provider</i> interamente italiano,</li>
				<li><a href="http://www.privatewave.com/home.html">
						<font color=blue> PrivateWave</font>
					</a>, soluzioni innovative nella <i>telefonia anti intercettazione</i>,</li>
				<li><a href="http://www.itwin.it/">
						<font color=blue> iTwin</font>
					</a>, token per <i>accesso cifrato</i> al tuo computer remoto.</li>
			</ul>
		</li>
	</ul>

</div>
<div id="Forum">
	<h3>Forum</h3>
	Per l'occasione è stato aperto un <a href="https://cryptowars2011.forumfree.it/">forum</a>.
</div>
<div id="categoriaClassica">
	<hr>
	<app-classica></app-classica>
	<hr>
	<app-pubblica></app-pubblica>
	<hr>
	<app-simmetrica></app-simmetrica>
	<hr>
</div>
<div id="cryptoCamp">
	<p>CryptoCamp già fatti:</p>
	<ul>
		<li>
			<font color=green> 13 Settembre 2011, ore 14.00 </font>
			<font color=red> Udine, Aula multimediale del DIMI</font>, <br>
			local organizer <i>Emanuele Pucciarelli </i> ep&#64;acm.org
		</li>
		<li>
			<font color=green> 14 Settembre 2011, 10.30 </font>
			<font color=red> Milano, DICo, via Golgi 19, Aula G07</font>, <br>
			local organizer <i>Mattia Monga </i> mattia.monga&#64;unimi.it
		</li>
		<li>
			<font color=green> 14 Settembre 2011, 14.30 </font>
			<font color=red>Crema (Cremona), Aula 2nord, Dip. di Tecnologie dell'Informazione (DTI)</font>, <br>
			local organizer <i>Mattia Monga </i> mattia.monga&#64;unimi.it
		</li>
		<li>
			<font color=green> 15 Settembre 2011, 09.00</font>
			<font color=red> Torino, Aula 4, Palazzo Campana, Dip. di Matematica</font>, <br>
			local organizer <i>Margherita Roggero</i> margherita.roggero&#64;unito.it
		</li>
		<li>
			<font color=green> 15 Settembre 2011, 15.00</font>
			<font color=red> Genova, Aula 710 DISI</font>, <br>
			local organizer <i>Teo Mora</i> theomora&#64;disi.unige.it
		</li>
		<li>
			<font color=green> 16 Settembre 2011, ore 10.00</font>,
			<font color=red> Pisa, Aula Magna Dip. di Matematica</font>, <br>
			local organizer <i>Sergio Steffè </i> steffe&#64;dm.unipi.it
		</li>
		<li>
			<font color=green> 19 Settembre 2011, ore 11.00 </font>
			<font color=red> Perugia, Aula A3 Dip. di Matematica</font>, <br>
			local organizer
			<i>Tommaso Gagliardoni </i> tommaso&#64;gagliardoni.net
		</li>
		<li>
			<font color=green> 26 Settembre 2011, ore 08.00 </font>
			<font color=red> Pergine, Scuola Superiore Marie Curie</font> <br>
			local organizer <i>Angela Aldrighetti </i>
		</li>
		<li>
			<font color=green> 29 Settembre 2011, ore 10.30 </font>
			<font color=red> Crema, Dip. di Tecnologie dell'Informazione (DTI)</font> <br>
			local organizer <i>Stelvio Cimato </i>stelvio.cimato&#64;unimi.it
		</li>
		<li>
			<font color=green> 29 Settembre 2011, ore 14.30</font>
			<font color=red> Milano, Aula Dottorato (I piano), Dip. di Matematica, via Saldini 50 </font><br>
			local organizer <i>Giovanni Naldi </i>giovanni.naldi&#64;unimi.it
		</li>
		<li>
			<font color=green> 5 Ottobre 2011, ore 10.00</font>
			<font color=red> Napoli, Centro Direzionale Isola C, Facoltà di Scienza e Tecnologia dell'Università di
				Parthenope, </font><br>
			local organizer <i>Giovanni Schmid </i> giovanni.schmid&#64;cnr.it
		</li>
		<li>
			<font color=green> 6 Ottobre 2011, ore 10.30</font>
			<font color=red> Milano, Aula V10, via Venezian 21, Dip. di Informatica </font><br>
			local organizer <i>Andrea Visconti </i> andrea.visconti&#64;unimi.it
		</li>
	</ul>
</div>